module.exports = __webpack_public_path__ + "df072ae72142de0cdf999ed412da563f.pdf";